module.exports = __webpack_public_path__ + "img/pro_three_6.2642a374.jpg";